import React from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  FormControl,
  FormLabel,
  Flex,
  Text,
  Stack,
  Select,
  Textarea,
  Input, // ✅ NEW
  useToast,
} from "@chakra-ui/react";

import * as FiIcons from "react-icons/fi";
import theme from "../../../global/theme";
import { pushNotifications } from "../../../../store/notifications/notificationsSlice";

const PushNotificationsModal = ({ onClose }) => {
  const dispatch = useDispatch();
  const notifications = useSelector((state) => state.notifications);

  const { t } = useTranslation();
  const toast = useToast({
    duration: 3000,
    status: "success",
    position: "top",
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  return (
    <Modal isOpen={true} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent borderRadius={4} paddingBlock={4} bg={theme.dark}>
        <form
          onSubmit={handleSubmit(async (values) => {
            try {
              console.log(values);
              await dispatch(pushNotifications(values)).unwrap();
              toast({
                description: `message sent to ${values.to} successfully`,
              });
              onClose();
            } catch (e) {
              console.log(e);
            }
          })}
        >
          <ModalHeader
            textAlign="center"
            color="orange"
            textTransform="uppercase"
            fontSize={22}
          >
            {t("general.create")}
          </ModalHeader>

          <ModalBody>
            <Stack spacing={4}>
              {/* 1) App Type */}
              <FormControl>
                <FormLabel
                  color={theme.light}
                  fontWeight="bold"
                  textTransform="capitalize"
                >
                  {t("general.app_type") || "App Type"}
                </FormLabel>
                <Select
                  bg={theme.light}
                  border="none"
                  borderRadius={4}
                  {...register("to", { required: t("validation.required") })}
                >
                  <option value="user">{t("general.user") || "user"}</option>
                  <option value="owner">
                    {t("general.owner") || "owner"}
                  </option>
                </Select>
                {errors.to?.message && (
                  <Text color="red.600" mt={2}>
                    {errors.to.message}
                  </Text>
                )}
              </FormControl>

              {/* 2) Title */}
              <FormControl>
                <FormLabel
                  color={theme.light}
                  fontWeight="bold"
                  textTransform="capitalize"
                >
                  {t("general.title") || "Title"}
                </FormLabel>
                <Input
                  bg={theme.light}
                  border="none"
                  borderRadius={4}
                  placeholder={t("general.title") || "Title"}
                  _placeholder={{ textTransform: "capitalize" }}
                  {...register("title", {
                    required: `${t("validation.required")}`,
                  })}
                />
                {errors.title?.message && (
                  <Text color="red.600" mt={2}>
                    {errors.title.message}
                  </Text>
                )}
              </FormControl>

              {/* 3) Description */}
              <FormControl>
                <FormLabel
                  color={theme.light}
                  fontWeight="bold"
                  textTransform="capitalize"
                >
                  {t("general.description") ||
                    t("general.message") ||
                    "Description"}
                </FormLabel>
                <Textarea
                  bg={theme.light}
                  border="none"
                  borderRadius={4}
                  placeholder={t("general.description") || "Description"}
                  _placeholder={{ textTransform: "capitalize" }}
                  {...register("message", {
                    required: `${t("validation.required")}`,
                  })}
                />
                {errors.message?.message && (
                  <Text color="red.600" mt={2}>
                    {errors.message.message}
                  </Text>
                )}
              </FormControl>
            </Stack>
          </ModalBody>

          <ModalFooter>
            <Flex justifyContent="flex-end">
              <Button
                type="submit"
                rightIcon={<FiIcons.FiSave />}
                color="white"
                bg="green"
                px={4}
                py={2}
                height="auto"
                textTransform="capitalize"
                isLoading={notifications.isLoading}
                _hover={{ background: "green" }}
              >
                {t("general.save")}
              </Button>
              <Button
                type="button"
                rightIcon={<FiIcons.FiMinimize2 />}
                color="white"
                bg="red.600"
                px={4}
                py={2}
                height="auto"
                textTransform="capitalize"
                ml={4}
                isLoading={notifications.isLoading}
                _hover={{ background: "red.600" }}
                onClick={onClose}
              >
                {t("general.close")}
              </Button>
            </Flex>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default PushNotificationsModal;
